import { defineMessage } from 'react-intl';
export const attachFilesOrImagesMessage = defineMessage({
    defaultMessage: 'Attach files or images',
    description: 'Menu item label for attaching files or images from the device',
    id: '0c142c5c03',
});
export const uploadFilesOrImagesMessage = defineMessage({
    defaultMessage: 'Upload files or images',
    description: 'Menu item label for uploading files or images from the device',
    id: '1e80cd029d',
});
//# sourceMappingURL=fileAttachmentMessages.js.map